import { Link } from "@inertiajs/react";
import App from "../layouts/app";
import { Pen } from 'lucide-react';
import { Statuses } from "./Competition";
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";


export default function Settings() {


    return (
        <App>
            <PageTitle title="Settings" />
            <ContentWrapper>
                Settings page content goes here.
            </ContentWrapper>
        </App >
    )
}